<template>
  <div class="edit-amount-input">
    <input class="update-amount-input"
           v-on:keypress="preventKeys"
           v-on:input="onInputToNumber"
           v-bind:value="updatedAmount"
           v-on:focus="onFocus($event.target)"
           type="tel"
           min="0"
           :placeholder="placeholder">
    <span class="nis-currency">₪</span>
  </div>
</template>

<script>
import * as _ from 'lodash';

export default {
  name: 'EditAmountInput',
  props: {
    updatedAmount: {
      type: Number,
    },
    placeholder: {
      type: String,
      required: false,
      default: '0',
    },
    onInput: {
      type: Function,
      required: true,
    },
  },
  methods: {
    preventKeys(event) {
      if (event.key === '-' || event.key === 'e') {
        return event.preventDefault();
      }
      return true;
    },
    onInputToNumber(event) {
      const numberValue = Number(event.target.value);
      if (_.isNaN(numberValue)) {
        throw new Error(`Amount is not a number. value: ${event.target.value}`);
      }
      this.onInput(numberValue);
    },
    onFocus(target) {
      target.select();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../scss/riseup-colors';
  @import '../scss/border-radius';

  .edit-amount-input {
    direction: rtl;

    .update-amount-input {
      color: $riseup_black;
      padding: 0px 12px;
      width: 210px;
      height: 64px;
      font-size: 46px;
      line-height: 46px;
      font-family: SimplerPro;
      font-weight: bold;
      border-radius: $input-field-border-radius;
      box-shadow: inset 0 0 6px 0 $riseup-black;
      border: solid 1px $riseup_black;
      background-color: $riseup_white;
      outline: none;
      direction: rtl;

      /* Remove up and down arrow */
      -moz-appearance: textfield;
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }

      &::placeholder {
        color: $riseup_gray_0;
      }
    }

    .nis-currency {
      vertical-align: text-top;
      font-weight: bold;
      font-size: 32px;
      margin-right: 12px;
      font-family: SimplerPro;
      color: $riseup_black;
    }
  }
</style>
